export default __webpack_public_path__ + "static/media/sevenev.0acb3830.png";